import { defineComponent as _defineComponent } from 'vue'
import { useDiffCheckModel } from '@features/diff-check'
import { AppSwitch } from '@shared/ui'


export default /*#__PURE__*/_defineComponent({
  __name: 'DiffCheckSwitch',
  props: {
  disabled: {
    type: Boolean,
    default: false
  }
},
  emits: ['toggleDiffCheck'],
  setup(__props, { emit }) {

const props = __props

const diffCheckModel = useDiffCheckModel()


const toggleDiffCheck = () => {
  emit('toggleDiffCheck')
}



return { __sfc: true,diffCheckModel, emit, toggleDiffCheck, props, AppSwitch }
}

})